import Selectors from './utils/selectors.js';
import RequestHandler from './utils/request-handler.js';

const selectors = new Selectors();

export default class FormPartValidator {
    constructor(options = {}) {
        this._options = {
            formSectionSelector: options.formSectionSelector,
            url: options.url,
            replacementSelector: options.replacementSelector || '.form-errors',
            eventName: 'blur',
            requestHandler: options.requestHandler || new RequestHandler(),
            document: options.document || document,
        };

        this._lastSubmittedDataJson = JSON.stringify(this._getFormData());

        this._bindInputs();
    }

    _getFormData() {
        let requestData = {
            'form[_token]': this._options.document.getElementsByName('form[_token]')[0].value
        };
        this._options.document.querySelector(this._options.formSectionSelector).querySelectorAll('input,select,textarea');
        this._findFields().forEach(field => requestData[field.getAttribute('name')] = field.value);
        return requestData;
    }

    _bindInputs() {
        const listener = this._triggerServerSideValidation.bind(this);
        this._findFields().forEach(field => field.addEventListener(this._options.eventName, listener));
    }

    _findFields() {
        return this._options.document.querySelector(this._options.formSectionSelector).querySelectorAll('input,select,textarea');
    }

    _triggerServerSideValidation() {
        const data = this._getFormData();
        const dataJson = JSON.stringify(data);
        if (dataJson === this._lastSubmittedDataJson) {
            return;
        }
        this._lastSubmittedDataJson = dataJson;
        this._options.requestHandler.post(this._options.url, data, (responseData) => {
            if (dataJson === this._lastSubmittedDataJson) {
                this._updateErrors(responseData);
            }
        });
    }

    _updateErrors(responseData) {
        const template = this._options.document.createElement('template');
        template.innerHTML = responseData.html.trim();

        let replacements = selectors.querySelectorArray(this._options.replacementSelector, template.content);

        replacements.forEach((newElem) => {
            const attribute = newElem.getAttribute('id');
            const oldElem = this._options.document.getElementById(attribute);
            if (!oldElem) {
                return;
            }
            oldElem.parentNode.replaceChild(newElem, oldElem);
        });
    }
}
